import appConfig from '../../appConfig';

const getGuiElementValue = (element) => {
  const elementName = element.getAttribute('data-element');
  switch (elementName) {
    case 'signin':
    case 'skip-register':
      return `${appConfig.getFlowId()}_page_node_link`;
    case 'signin-InputNode':
      return `${appConfig.getFlowId()}_input_node_link`;
    case 'signup_facebook':
    case 'signup_google':
     return elementName;
    case 'card-button':
      return `${appConfig.getFlowId()}:${elementName}:${element.getAttribute('data-target-flow')}`;
    case 'language-selection':
      return `flag_${element.getAttribute('data-learn-language')}`;
    default:
      return elementName;
  }
};

export default (element) => ({
  origin: 'ppf',
  interaction: 'clicked',
  gui_element: getGuiElementValue(element)
});
